var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuarterNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 7 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g11065",
    transform: "matrix(0.48013544,0,0,0.48013544,-211.71874,-4.5468223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path11056",
    d: "m 451.09,49.39 c 3.3958,-1.82 5.2053,-5.1146 4.0922,-7.593 -1.1873,-2.6436 -5.267,-3.3897 -9.1066,-1.6654 -3.8396,1.7244 -5.9922,5.2694 -4.8049,7.913 1.1873,2.6436 5.267,3.3897 9.1066,1.6654 0.23997,-0.10777 0.48628,-0.19874 0.71268,-0.32007 z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11058",
    d: "M 454.73,43.056 V 9.468",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarterNote);
export default __webpack_public_path__ + "static/media/quarter-note.b77b03d49c4a9c5e84a13ea9d5dce73a.svg";
export { ForwardRef as ReactComponent };